import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KzDropdownComponent } from './kz-dropdown.component';
import { KzDropdownItemDirective } from './kz-dropdown-item.directive';
import { KzClickOutsideModule } from '../click-outside/kz-click-outside.module';
import { MediaQueriesService } from '../../utils/media-queries.service';
import { KzDropdownService } from './kz-dropdown.service';
import { KzIconsModule } from '../icon/kz-icons.module';

@NgModule({
  imports: [
    CommonModule,
    KzClickOutsideModule,
    KzIconsModule,
  ],
  declarations: [
    KzDropdownComponent,
    KzDropdownItemDirective,
  ],
  exports: [
    KzDropdownComponent,
    KzDropdownItemDirective,
  ],
  providers: [
    MediaQueriesService,
    KzDropdownService,
  ]
})
export class KzDropdownModule { }
